import { render, staticRenderFns } from "./AIUserMessage.vue?vue&type=template&id=52b930e6&scoped=true"
import script from "./AIUserMessage.vue?vue&type=script&lang=js"
export * from "./AIUserMessage.vue?vue&type=script&lang=js"
import style0 from "./AIUserMessage.vue?vue&type=style&index=0&id=52b930e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b930e6",
  null
  
)

export default component.exports